import { Button, Grid, IconButton, Typography } from "@mui/material";
import React, { useState } from "react";
import { DataGrid } from "@mui/x-data-grid";

import { useNavigate } from "react-router-dom";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import { WSIcons } from "../../../commonFunctions/iIcons";
import WSSelectField from "../../../Components/Select/WSSelect";
import { useForm } from "react-hook-form";
import config from "../../../Config/clientConfig.json";
import WSDateField from "../../../Components/DateField/WSDateField";

export const PayOuts: React.FC<any> = React.memo((props) => {
  const { register, control } = useForm();
  const navigate = useNavigate();

  const columns: IColumns[] = [
    {
      header: "date",
      fieldName: "workLocationName",
      tooltip: true,
    },
    {
      header: "paid to",
      fieldName: "address",
      tooltip: true,
    },
    {
      header: "Payment type",
      fieldName: "address",
      tooltip: true,
    },
    {
      header: "Voucher#",
      fieldName: "address",
      tooltip: true,
    },
    {
      header: "Amount",
      fieldName: "address",
      tooltip: true,
    },
    {
      header: "Remark",
      fieldName: "address",
      tooltip: true,
    },
  ];

  const handleClick = (path: string) => {
    navigate(path);
  };

  return (
    <Grid container direction="column" sx={{ minHeight: "100vh" }}>
      {/* Header Section */}
      <Grid item>
        <Grid
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "16px",
          }}
        >
          {/* Title on the left */}
          <Typography variant="h6" sx={{ fontWeight: "bold", color: "green" }}>
            Pay Outs
          </Typography>
          <Grid sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <WSSelectField
              rules={{ required: true }}
              {...register("extraservice")}
              id="extraservice"
              control={control}
              defaultValue={"0"}
              label=""
              name="extraservice"
              options={config.extraserviceConfig.staticOptionData}
            />

            <WSDateField
              id="date"
              name="date"
              dateFormat="D/MM/YYYY"
              control={control}
              defaultValue={null}
              rules={{ required: true }}
              label={""}
            />
            <IconButton>
              <WSIcons.CloseIcon
                sx={{ backgroundColor: "red", color: "white" }}
                onClick={() => handleClick("/")}
              />
            </IconButton>
          </Grid>
        </Grid>
      </Grid>

      {/* DataGrid Section */}
      <Grid item sx={{ flex: 1 }}>
        <WSDataGrid id="itemGrid" title="" columns={columns} />
      </Grid>

      <Grid
        bgcolor="#333"
        p={2}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <WSIcons.GTranslateIcon sx={{ color: "white" }} />
        <Grid display="flex" ml="auto" gap={4}>
          <Button
            variant="outlined"
            sx={{ borderColor: "green", color: "white" }}
          >
            Reprint
          </Button>
          <Button
            variant="outlined"
            sx={{ borderColor: "green", color: "white" }}
          >
            Void
          </Button>
          <Button
            variant="outlined"
            sx={{ borderColor: "green", color: "white" }}
          >
            Recall
          </Button>
          <Button
            variant="contained"
            color="success"
            onClick={() => handleClick("/payout")}
          >
            Add
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
});
